<template>
  <v-layout>
    <v-card class="elevation-0" style="flex: auto;">
      <v-card-text>
        <span class="text"
          >Visitor Type: {{ (vistor.type || "N/A").toUpperCase() }}</span
        >
        <br />
        <br />
        <v-btn-toggle fluid v-model="vistor.type" class="d-flex mb-5" flat>
          <v-btn value="visitor" color="info">Visitor</v-btn>
          <v-btn value="volunteer" color="info">Volunteer</v-btn>
          <v-btn value="parent" color="info">Parent</v-btn>
        </v-btn-toggle>
        <v-layout row wrap class="pl-3 pr-3">
          <v-text-field
            class="mr-5"
            label="First Name"
            v-model="vistor.first_name"
            maxlength="25"
          ></v-text-field>
          <v-text-field
            label="Last Name"
            v-model="vistor.last_name"
            maxlength="25"
          ></v-text-field>
        </v-layout>
        <v-layout row wrap class="pl-3 pr-3">
          <v-text-field
            class="mr-5"
            mask="phone"
            label="Mobile"
            v-model="vistor.mobile"
          ></v-text-field>
          <v-text-field
            maxlength="100"
            label="E-mail"
            v-model="vistor.email"
            :rules="[rules.required, rules.email]"
          ></v-text-field>
        </v-layout>
        <v-layout row wrap class="pl-3 pr-3" v-if="permitted('wwcc')">
          <v-flex lg4 md6 class="pa-0">
            <v-text-field
              label="Card No"
              v-model="vistor.wwcc_no"
              maxlength="8"
            >
              <template v-slot:append>
                <v-btn
                  small
                  v-if="vistor.wwcc_no"
                  color="info"
                  @click="checkCardNo()"
                  >Check</v-btn
                >
              </template>
            </v-text-field>
          </v-flex>
          <label style="display: flex; align-items: center;" class="ml-3">{{
            wwccResponse.message
          }}</label>
        </v-layout>
        <v-checkbox
          label="Ticking this will skip the print label when the person uses their quickcode to sign in or out."
          v-model="vistor.enable_print_label"
          required
        ></v-checkbox>
      </v-card-text>
      <div style="display: flex; justify-content: flex-end;" class="mb-3 mr-1">
        <v-btn
          v-if="vistor._id"
          color="error"
          float="right"
          small
          @click="removeUser"
          >Delete</v-btn
        >
        <v-btn
          color="info"
          float="right"
          small
          type="submit"
          @click="createUser"
          >Submit</v-btn
        >
      </div>
    </v-card>
  </v-layout>
</template>

<script>
import APIVisitor from "@/mixins/APIVisitor";
export default {
  components: {},
  mixins: [APIVisitor],
  data() {
    return {
      row: null,
      checkStatus: {},
      wwccResponse: {},
      vistor: {
        type: "visitor",
        join_date: "",
        company: "",
        role: 1,
        wwcc_message: ""
      },
      titles: [
        {
          title: "Parent",
          value: "parent"
        },
        {
          title: "Volunteer",
          value: "volunteer"
        },
        {
          title: "Visitor",
          value: "visitor"
        }
      ],
      message: [
        {
          title: "yes",
          value: "yes"
        },
        {
          title: "no",
          value: "no"
        },
        {
          title: "yes not with me",
          value: "yes not with me"
        }
      ],
      email: "",
      rules: {
        required: value => !!value || "Required.",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  created() {
    this.restoreFrom();
  },
  methods: {
    removeUser: async function() {
      if (!this.vistor._id) {
        this.$toast.error("Failed to delete visitor.", "Error");
        return;
      }
      let self = this;
      this.$swal({
        title: "Are you sure?",
        text: "You can't revert your action",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true
      }).then(async result => {
        if (result.value) {
          try {
            await this.deleteVisitor(this.vistor._id);
            self.$router.push({
              name: "Visitors"
            });
          } catch (error) {
            this.$toast.error(error || "Failed to delete visitor.", "Error");
          }
          this.$swal(
            "Deleted",
            "You successfully deleted this file",
            "success"
          );
        } else {
          this.$swal("Cancelled", "Your file is still intact", "info");
        }
      });
    },
    createUser: async function() {
      try {
        if (this.vistor._id) {
          await this.putVistor(this.vistor);
        } else {
          await this.postVistor(this.vistor);
        }
        this.$toast.success("Details updated successfully", "Success", {
          position: "topCenter"
        });
      } catch (error) {
        if (String(error) === "Error: Network Error") {
          this.$toast.error(String(error), "", {
            position: "topCenter"
          });
        } else {
          this.$toast.error("Failed to submit details", "Error", {
            position: "topCenter"
          });
        }
      }
    },
    restoreFrom: async function() {
      if (this.$route.params.object) {
        this.vistor = this.$route.params.object;
      } else if (this.$route.params.id) {
        try {
          await this.geVistorById(this.$route.params.id);
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", {
            position: "topCenter"
          });
        }
      }
    },
    checkCardNo: async function() {
      if (!this.vistor.wwcc_no && this.vistor.wwcc_no.length === 0) {
        this.$toast.error("WWCC number can not be empty!", "Error", {
          position: "topCenter"
        });
        return;
      }
      if (!this.vistor.last_name && this.vistor.last_name.length === 0) {
        this.$toast.error("Last name can not be empty!", "Error", {
          position: "topCenter"
        });
        return;
      }
      this.checkStatus.card_no = this.vistor.wwcc_no;
      this.checkStatus.last_name = this.vistor.last_name;
      this.checkStatus.holder_type = this.vistor.type;
      try {
        let responce = await this.postVistorrCheck(this.checkStatus);
        if (responce.code === 420) {
          this.wwccResponse = responce;
          this.$toast.error(responce.message, "WWCC Error", {
            position: "topCenter"
          });
        } else {
          this.wwccResponse = responce;
          this.$toast.success(
            responce.message || "Successfully checked the WWCC status.",
            responce.message ? "" : "Success",
            { position: "topCenter" }
          );
        }
      } catch (error) {
        this.$toast.error(String(error), "", {
          position: "topCenter"
        });
      }
    }
  }
};
</script>
